import { answerGroup } from "@/utils/gloableVariable";
export const questionMixin = {
  props: {
    // 题目信息
    datas: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 题目编号
    index: {
      type: Number,
      default: 1
    },
    // 当前题目id
    currentId: {
      type: String,
      default: ""
    },
    // 是否显示查看解析
    isAnalysis: {
      type: Boolean,
      default: false
    },
    // 大题是否显示查看解析
    isAnalysisDt: {
      type: Boolean,
      default: false
    },
    // 输入框是否只读
    isDisabled: {
      type: Boolean,
      default: false
    },
    isHideName: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      answerGroup: answerGroup,
      qStyle: ["", "单选题", "判断题", "多选题", "填空题", "简答题"]
    };
  },
  mounted() {
    
  },
  methods: {
    toggleClass(status) {
      switch (status) {
        case 1: //已做
          return "active";
        case 0: //未做
          return "notDone";
        case "correct": //正确
          return "success";
        case 2: //错误
          return "error";
        case 3: //部分正确
          return "partiallyCorrect";
        case "unread": //未阅
          return "partiallyCorrect";
        default:
          return "";
      }
    },
    showAnalysis() {
      this.$emit("showAnalysis", this.datas.id);
    },
    theRadio(val) {
      this.$emit("next", false);
    },
    // 阻止事件冒泡
    preventHandler(event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }
};
